import React, { useState } from 'react';
import { login } from '../Admin/Api.js';
import { useNavigate } from 'react-router-dom';
import './Login.css'; // Importiere die CSS-Datei für das Login

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate(); // useNavigate-Hook zur Navigation verwenden

    const handleLogin = async (e) => {
        e.preventDefault();
        setError("");

        try {
            const { token, name, role } = await login(username, password);

            if (!name || name.trim() === "") {
                throw new Error("Benutzername nicht verfügbar.");
            }

            localStorage.setItem("token", token);
            localStorage.setItem("username", name);
            localStorage.setItem("role", role);

            alert(`Login erfolgreich, ${name}!`);
            navigate("/");
        } catch (err) {
            setError(err.message); // User bleibt auf der Seite
        }
    };



    const handleRegisterClick = () => {
        navigate('/register'); // Zur Registrieren-Seite navigieren
    };

    return (
        <div className="login-container"> {/* Container für das Login-Formular */}
            <h2>Login</h2>
            {error && <p style={{ color: 'red' }}>{error}</p>}
            <form onSubmit={handleLogin}>
                <label>Benutzername</label>
                <input
                    type="text"
                    placeholder="Benutzername"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    required
                />
                <label>Passwort</label>
                <input
                    type="password"
                    placeholder="Passwort"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                />
                <button type="submit">Login</button>
            </form>
            <p>Du hast noch keinen Account?</p>
            <p className="register-link" onClick={handleRegisterClick}>
                Hier registrieren!
            </p>
        </div>
    );
};

export default Login;
